import LegalLayout from "@/components/site/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="December 2025">
      <section data-testid="terms-intro">
        <p>
          Welcome to Mahaview.in. By accessing or using our website and services, you agree to be
          bound by these Terms & Conditions. If you do not agree, please do not use our services.
        </p>
      </section>

      <section>
        <h2>1. Services</h2>
        <p>
          Mahaview.in provides website development, social media management, digital marketing,
          graphics designing, live streaming, and portfolio/PPT services. Scope, deliverables, and
          timelines for each engagement are defined in a separate proposal or contract.
        </p>
      </section>

      <section>
        <h2>2. Use of the Website</h2>
        <ul>
          <li>Use this site only for lawful purposes.</li>
          <li>Do not attempt to gain unauthorised access, disrupt operations, or scrape content.</li>
          <li>Do not submit false or misleading information through our forms.</li>
        </ul>
      </section>

      <section>
        <h2>3. Intellectual Property</h2>
        <p>
          All content on this site — including text, graphics, logos, designs, and code — is the
          property of Mahaview.in or its licensors and is protected by applicable IP laws. You may
          not reuse it without prior written permission.
        </p>
      </section>

      <section>
        <h2>4. Quotes, Payments &amp; Deliverables</h2>
        <ul>
          <li>Quotes are valid for 30 days from the date of issue unless otherwise stated.</li>
          <li>Payment terms (advance, milestones, balance) are specified per project.</li>
          <li>Final deliverables are transferred after full payment is received.</li>
        </ul>
      </section>

      <section>
        <h2>5. Revisions &amp; Approvals</h2>
        <p>
          Each project includes a defined number of revision rounds. Additional revisions may be
          billed separately. Once a deliverable is approved, further changes may be treated as a
          new scope of work.
        </p>
      </section>

      <section>
        <h2>6. Cancellation &amp; Refunds</h2>
        <p>
          Advance payments are non-refundable once work has commenced. For cancellations,
          we will bill for work completed up to that point; remaining amounts (if any) may be
          refunded at our discretion.
        </p>
      </section>

      <section>
        <h2>7. Confidentiality</h2>
        <p>
          Both parties agree to keep confidential information shared during an engagement
          confidential and to use it only for the purpose of delivering the agreed services.
        </p>
      </section>

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Mahaview.in is not liable for any indirect,
          incidental, or consequential damages arising from your use of our website or services.
          Our total liability is limited to the amount paid for the specific service in question.
        </p>
      </section>

      <section>
        <h2>9. Third-Party Platforms</h2>
        <p>
          We may use third-party platforms (hosting providers, ad networks, social media). Their
          terms and policies apply in addition to ours.
        </p>
      </section>

      <section>
        <h2>10. Governing Law</h2>
        <p>
          These Terms are governed by the laws of India. Any disputes shall be subject to the
          exclusive jurisdiction of the courts at Pune, Maharashtra.
        </p>
      </section>

      <section>
        <h2>11. Changes to These Terms</h2>
        <p>
          We may revise these Terms from time to time. Continued use of the website after changes
          constitutes acceptance of the updated Terms.
        </p>
      </section>

      <section>
        <h2>12. Contact Us</h2>
        <p>
          Questions about these Terms? Reach us at{" "}
          <a href="mailto:mahaview1@gmail.com">mahaview1@gmail.com</a> or +91 80972 08707.
        </p>
      </section>
    </LegalLayout>
  );
}
